import { useEffect, useRef } from 'react';

import { fx } from '../utils/fx';

// Fase live-A — cuenta regresiva → 0. Corre en [countdown_at, opens_at) del
// bloque countdown del contrato (duración = countdown_seconds, variable). Muy
// animada + colores que escalan con el progreso. Tick sonoro por segundo; los
// últimos 3s vibran fuerte. Props: secondsLeft (int), progress (0..1).
export default function Countdown({ secondsLeft, progress }) {
    const last = useRef(secondsLeft);
    useEffect(() => {
        if (secondsLeft !== last.current) {
            last.current = secondsLeft;
            if (secondsLeft > 0) {
                fx.tick();
                if (secondsLeft <= 3) fx.vibrate?.(60);
            }
        }
    }, [secondsLeft]);

    // Tono por PROGRESO (0..1), no por segundos absolutos: así escala con
    // cualquier countdown_seconds del contrato (10, 20, …), no sólo 20.
    const tone = progress < 0.5 ? 'go' : progress < 0.8 ? 'warn' : 'hot';
    const urgent = secondsLeft <= 3;
    const R = 132;
    const C = 2 * Math.PI * R;

    return (
        <div className={`evx__cd evx__cd--${tone} ${urgent ? 'evx__cd--urgent' : ''}`}>
            <span className="evx__cd-eyebrow">La puja arranca en</span>

            <div className="evx__cd-ring">
                <svg viewBox="0 0 300 300" aria-hidden="true">
                    <circle className="evx__cd-track" cx="150" cy="150" r={R} />
                    <circle
                        className="evx__cd-arc" cx="150" cy="150" r={R}
                        strokeDasharray={C}
                        strokeDashoffset={C * Math.min(1, Math.max(0, progress))}
                        transform="rotate(-90 150 150)"
                    />
                </svg>
                <span key={secondsLeft} className="evx__cd-num">{secondsLeft}</span>
            </div>

            <span className="evx__cd-msg">{urgent ? '¡Ya casi!' : '¡Prepárate!'}</span>
        </div>
    );
}
